import cygnusSpriteHtml from "@root/services/icons/cygnusSpriteHtml";

export default function (cell, formatterParams, onRendered) {
  const value = cell.getValue();
  const { financeOpportunitiesAccepted } = formatterParams;
  const el = document.createElement('div');
  el.classList.add('d-flex', 'flex-column', 'align-items-center');

  let icon = 'x-circle';
  let color = 'danger';

  if (financeOpportunitiesAccepted && value) {
    icon = 'check-circle';
    color = 'success';
  } else if (financeOpportunitiesAccepted && !value) {
    icon = 'x-circle';
    color = 'warning';
  }

  let iconEl = cygnusSpriteHtml(icon, { variant: 'solid', className: `text-${color}` });


  el.innerHTML = `<div>${iconEl}</div>`;
  return el;
}
